import { SVGProps } from "types";

const IllustrationServer = (props: SVGProps) => {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2042_6610)">
        <path
          d="M53.2942 15.3575C49.6109 6.30503 40.7008 -0.0636297 30.3101 0.000479654C17.0544 0.0821203 6.15543 10.7743 5.83385 24.0262C5.67521 30.5643 8.06445 36.5423 12.0788 41.0389C15.2789 44.6235 16.8849 49.3448 16.723 54.1475C16.7015 54.7858 16.6982 55.4288 16.7141 56.0759C17.1376 73.504 32.0259 88.0105 49.4592 88C67.5289 87.9892 82.1738 73.3373 82.1738 55.2652C82.1738 42.0181 74.3047 30.61 62.9862 25.4581C58.5747 23.4501 55.1209 19.8469 53.2942 15.3575Z"
          fill="url(#paint0_linear_2042_6610)"
        />
        <g opacity="0.1">
          <path
            opacity="0.1"
            d="M70.6977 10.9375H17.3027C16.3524 10.9375 15.582 11.7078 15.582 12.6581V19.5478C15.582 20.498 16.3524 21.2684 17.3027 21.2684H70.6975C71.6478 21.2684 72.4182 20.498 72.4182 19.5478V12.6581C72.4182 11.7078 71.6478 10.9375 70.6977 10.9375Z"
            fill="#2626BC"
          />
          <path
            opacity="0.1"
            d="M70.6977 27.5713H17.3027C16.3524 27.5713 15.582 28.3416 15.582 29.2919V36.1815C15.582 37.1318 16.3524 37.9022 17.3027 37.9022H70.6975C71.6478 37.9022 72.4182 37.1318 72.4182 36.1815V29.2919C72.4182 28.3416 71.6478 27.5713 70.6977 27.5713Z"
            fill="#2626BC"
          />
          <path
            opacity="0.1"
            d="M70.6977 44.2051H17.3027C16.3524 44.2051 15.582 44.9754 15.582 45.9257V52.8153C15.582 53.7656 16.3524 54.536 17.3027 54.536H70.6975C71.6478 54.536 72.4182 53.7656 72.4182 52.8153V45.9257C72.4182 44.9754 71.6478 44.2051 70.6977 44.2051Z"
            fill="#2626BC"
          />
          <path
            opacity="0.1"
            d="M56.8187 66.5791H31.1818C30.2315 66.5791 29.4612 67.3494 29.4612 68.2997V71.7328C29.4612 72.6831 30.2315 73.4534 31.1818 73.4534H56.8187C57.769 73.4534 58.5393 72.6831 58.5393 71.7328V68.2997C58.5392 67.3494 57.7688 66.5791 56.8187 66.5791Z"
            fill="#2626BC"
          />
        </g>
        <path
          d="M46.5518 56.5518V61.1974C46.5518 62.1472 45.7827 62.918 44.8312 62.918H43.1691C42.2176 62.918 41.4485 62.1472 41.4485 61.1974V56.5518H46.5518Z"
          fill="#6583FE"
        />
        <path
          d="M41.4485 56.5518H46.5518V60.2665H41.4485V56.5518Z"
          fill="#4369FD"
        />
        <path
          d="M18.6506 22.5244H69.3495V50.5115H18.6506V22.5244Z"
          fill="#6583FE"
        />
        <path
          d="M18.6506 22.5244H69.3495V27.3197H18.6506V22.5244Z"
          fill="#4369FD"
        />
        <path
          d="M18.6506 33.6221H69.3495V43.9524H18.6506V33.6221Z"
          fill="#4369FD"
        />
        <path
          d="M70.6977 24.8778H17.3027C16.3524 24.8778 15.582 24.1074 15.582 23.1571V16.2675C15.582 15.3172 16.3524 14.5469 17.3027 14.5469H70.6975C71.6478 14.5469 72.4182 15.3172 72.4182 16.2675V23.1571C72.4182 24.1074 71.6478 24.8778 70.6977 24.8778Z"
          fill="#FF7EB8"
        />
        <path
          d="M23.3097 20.6751C23.8416 20.6751 24.2727 20.2439 24.2727 19.712C24.2727 19.1802 23.8416 18.749 23.3097 18.749C22.7778 18.749 22.3467 19.1802 22.3467 19.712C22.3467 20.2439 22.7778 20.6751 23.3097 20.6751Z"
          fill="#FFC4DF"
        />
        <path
          d="M26.223 20.6751C26.7549 20.6751 27.186 20.2439 27.186 19.712C27.186 19.1802 26.7549 18.749 26.223 18.749C25.6912 18.749 25.26 19.1802 25.26 19.712C25.26 20.2439 25.6912 20.6751 26.223 20.6751Z"
          fill="#FFC4DF"
        />
        <path
          d="M29.1361 20.6751C29.668 20.6751 30.0991 20.2439 30.0991 19.712C30.0991 19.1802 29.668 18.749 29.1361 18.749C28.6043 18.749 28.1731 19.1802 28.1731 19.712C28.1731 20.2439 28.6043 20.6751 29.1361 20.6751Z"
          fill="#FFC4DF"
        />
        <path
          d="M48.6415 18.8506H35.4384C34.9884 18.8506 34.5864 19.1796 34.5436 19.6276C34.4946 20.1415 34.8973 20.5741 35.4012 20.5741H48.6413C49.1172 20.5741 49.5031 20.1883 49.5031 19.7124C49.5033 19.2364 49.1174 18.8506 48.6415 18.8506Z"
          fill="#D2DEFF"
        />
        <path
          d="M65.7614 18.8506H52.5582C52.1083 18.8506 51.7063 19.1796 51.6635 19.6276C51.6145 20.1415 52.0172 20.5741 52.5211 20.5741H65.7612C66.2371 20.5741 66.623 20.1883 66.623 19.7124C66.6231 19.2364 66.2373 18.8506 65.7614 18.8506Z"
          fill="#97FFD2"
        />
        <path
          d="M70.6977 41.5116H17.3027C16.3524 41.5116 15.582 40.7412 15.582 39.7909V32.9013C15.582 31.951 16.3524 31.1807 17.3027 31.1807H70.6975C71.6478 31.1807 72.4182 31.951 72.4182 32.9013V39.7909C72.4182 40.7414 71.6478 41.5116 70.6977 41.5116Z"
          fill="#FF7EB8"
        />
        <path
          d="M23.3097 37.3088C23.8416 37.3088 24.2727 36.8777 24.2727 36.3458C24.2727 35.814 23.8416 35.3828 23.3097 35.3828C22.7778 35.3828 22.3467 35.814 22.3467 36.3458C22.3467 36.8777 22.7778 37.3088 23.3097 37.3088Z"
          fill="#FFC4DF"
        />
        <path
          d="M26.223 37.3088C26.7549 37.3088 27.186 36.8777 27.186 36.3458C27.186 35.814 26.7549 35.3828 26.223 35.3828C25.6912 35.3828 25.26 35.814 25.26 36.3458C25.26 36.8777 25.6912 37.3088 26.223 37.3088Z"
          fill="#FFC4DF"
        />
        <path
          d="M29.1361 37.3088C29.668 37.3088 30.0991 36.8777 30.0991 36.3458C30.0991 35.814 29.668 35.3828 29.1361 35.3828C28.6043 35.3828 28.1731 35.814 28.1731 36.3458C28.1731 36.8777 28.6043 37.3088 29.1361 37.3088Z"
          fill="#FFC4DF"
        />
        <path
          d="M48.6415 35.4844H35.4384C34.9884 35.4844 34.5864 35.8133 34.5436 36.2614C34.4946 36.7753 34.8973 37.2079 35.4012 37.2079H48.6413C49.1172 37.2079 49.5031 36.8221 49.5031 36.3462C49.5033 35.8702 49.1174 35.4844 48.6415 35.4844Z"
          fill="#D2DEFF"
        />
        <path
          d="M65.7614 35.4844H52.5582C52.1083 35.4844 51.7063 35.8133 51.6635 36.2614C51.6145 36.7753 52.0172 37.2079 52.5211 37.2079H65.7612C66.2371 37.2079 66.623 36.8221 66.623 36.3462C66.6231 35.8702 66.2373 35.4844 65.7614 35.4844Z"
          fill="#97FFD2"
        />
        <path
          d="M70.6977 58.1453H17.3027C16.3524 58.1453 15.582 57.375 15.582 56.4247V49.5351C15.582 48.5848 16.3524 47.8145 17.3027 47.8145H70.6975C71.6478 47.8145 72.4182 48.5848 72.4182 49.5351V56.4247C72.4182 57.375 71.6478 58.1453 70.6977 58.1453Z"
          fill="#FF7EB8"
        />
        <path
          d="M23.3097 53.9426C23.8416 53.9426 24.2727 53.5115 24.2727 52.9796C24.2727 52.4478 23.8416 52.0166 23.3097 52.0166C22.7778 52.0166 22.3467 52.4478 22.3467 52.9796C22.3467 53.5115 22.7778 53.9426 23.3097 53.9426Z"
          fill="#FFC4DF"
        />
        <path
          d="M26.223 53.9426C26.7549 53.9426 27.186 53.5115 27.186 52.9796C27.186 52.4478 26.7549 52.0166 26.223 52.0166C25.6912 52.0166 25.26 52.4478 25.26 52.9796C25.26 53.5115 25.6912 53.9426 26.223 53.9426Z"
          fill="#FFC4DF"
        />
        <path
          d="M29.1361 53.9426C29.668 53.9426 30.0991 53.5115 30.0991 52.9796C30.0991 52.4478 29.668 52.0166 29.1361 52.0166C28.6043 52.0166 28.1731 52.4478 28.1731 52.9796C28.1731 53.5115 28.6043 53.9426 29.1361 53.9426Z"
          fill="#FFC4DF"
        />
        <path
          d="M48.6415 52.1182H35.4384C34.9884 52.1182 34.5864 52.4471 34.5436 52.8952C34.4946 53.4091 34.8973 53.8417 35.4012 53.8417H48.6413C49.1172 53.8417 49.5031 53.4559 49.5031 52.9799C49.5033 52.504 49.1174 52.1182 48.6415 52.1182Z"
          fill="#D2DEFF"
        />
        <path
          d="M65.7614 52.1182H52.5582C52.1083 52.1182 51.7063 52.4471 51.6635 52.8952C51.6145 53.4091 52.0172 53.8417 52.5211 53.8417H65.7612C66.2371 53.8417 66.623 53.4559 66.623 52.9799C66.6231 52.504 66.2373 52.1182 65.7614 52.1182Z"
          fill="#97FFD2"
        />
        <path
          d="M56.8184 77.0628H31.1816C30.2313 77.0628 29.4609 76.2924 29.4609 75.3421V71.9091C29.4609 70.9588 30.2313 70.1885 31.1816 70.1885H56.8184C57.7687 70.1885 58.5391 70.9588 58.5391 71.9091V75.3421C58.5389 76.2924 57.7686 77.0628 56.8184 77.0628Z"
          fill="#6583FE"
        />
        <path
          d="M80.1411 72.7661H59.3984V71.9089C59.3984 70.4863 58.2411 69.3289 56.8185 69.3289H48.7385C48.2638 69.3289 47.8791 69.7136 47.8791 70.1883C47.8791 70.663 48.2638 71.0477 48.7385 71.0477H56.8185C57.2934 71.0477 57.6796 71.434 57.6796 71.9089V75.342C57.6796 75.8169 57.2934 76.2032 56.8185 76.2032H31.1816C30.7067 76.2032 30.3204 75.8169 30.3204 75.342V71.9089C30.3204 71.434 30.7067 71.0477 31.1816 71.0477H44.0001C44.4748 71.0477 44.8595 70.663 44.8595 70.1883V63.776C46.2693 63.7609 47.4118 62.6107 47.4118 61.1973V59.0047H70.6976C72.12 59.0047 73.2774 57.8475 73.2774 56.4247V49.5351C73.2774 48.1125 72.1202 46.9551 70.6976 46.9551H70.2095V42.3709H70.6976C72.12 42.3709 73.2774 41.2136 73.2774 39.7908V32.9012C73.2774 31.4786 72.1202 30.3212 70.6976 30.3212H70.2095V25.737H70.6976C72.12 25.737 73.2774 24.5797 73.2774 23.157V16.2675C73.2774 14.8449 72.1202 13.6875 70.6976 13.6875H17.3024C15.8798 13.6875 14.7224 14.8447 14.7224 16.2675V23.1571C14.7224 24.5797 15.8798 25.7371 17.3024 25.7371H17.7905V30.3214H17.3024C15.8798 30.3214 14.7224 31.4786 14.7224 32.9014V39.791C14.7224 41.2136 15.8798 42.371 17.3024 42.371H17.7905V46.9553H17.3024C15.8798 46.9553 14.7224 48.1125 14.7224 49.5353V56.4249C14.7224 57.8475 15.8798 59.0049 17.3024 59.0049H40.5884V61.1977C40.5884 62.611 41.7308 63.7612 43.1405 63.7763V69.3293H31.1815C29.7589 69.3293 28.6014 70.4865 28.6014 71.9093V72.7664H7.85889C7.38434 72.7664 6.99951 73.1511 6.99951 73.6258C6.99951 74.1005 7.38434 74.4852 7.85889 74.4852H28.6018V75.3421C28.6018 76.7648 29.7592 77.9222 31.1818 77.9222H56.8187C58.2411 77.9222 59.3985 76.7649 59.3985 75.3421V74.4852H80.1414C80.6162 74.4852 81.0008 74.1005 81.0008 73.6258C81.0008 73.1511 80.6158 72.7661 80.1411 72.7661ZM16.4415 23.1571V16.2675C16.4415 15.7926 16.8278 15.4062 17.3027 15.4062H70.6978C71.1727 15.4062 71.5589 15.7926 71.5589 16.2675V23.1571C71.5589 23.632 71.1727 24.0184 70.6978 24.0184H17.3024C16.8277 24.0184 16.4413 23.632 16.4415 23.1571ZM16.4415 39.791V32.9014C16.4415 32.4265 16.8278 32.0401 17.3027 32.0401H18.6507C19.1253 32.0401 19.5101 31.6555 19.5101 31.1808C19.5101 31.1787 19.5096 31.177 19.5096 31.1749V25.7371H68.4909V30.3214H23.3893C22.9148 30.3214 22.53 30.706 22.53 31.1808C22.53 31.6555 22.9148 32.0401 23.3893 32.0401H70.6978C71.1727 32.0401 71.5589 32.4265 71.5589 32.9014V39.791C71.5589 40.2659 71.1727 40.6523 70.6978 40.6523H17.3026C16.8278 40.6521 16.4415 40.2657 16.4415 39.791ZM19.5094 42.3709H68.4907V46.9551H19.5094V42.3709ZM16.4415 56.4247V49.5351C16.4415 49.0602 16.8278 48.6738 17.3027 48.6738H70.6978C71.1727 48.6738 71.5589 49.0602 71.5589 49.5351V56.4247C71.5589 56.8996 71.1727 57.286 70.6978 57.286H17.3024C16.8277 57.286 16.4413 56.8996 16.4415 56.4247ZM42.3073 61.1975V59.0047H45.693V61.1975C45.693 61.6724 45.3067 62.0588 44.8318 62.0588H43.1685C42.6937 62.0586 42.3073 61.6722 42.3073 61.1975Z"
          fill="#2626BC"
        />
        <path
          d="M69.8477 68.5973C69.3729 68.5973 68.9883 68.2127 68.9883 67.738C68.9883 67.1668 68.5235 66.7021 67.9524 66.7021C67.4777 66.7021 67.093 66.3174 67.093 65.8427C67.093 65.368 67.4777 64.9833 67.9524 64.9833C68.5235 64.9833 68.9883 64.5186 68.9883 63.9473C68.9883 63.4725 69.3729 63.0879 69.8477 63.0879C70.3224 63.0879 70.707 63.4725 70.707 63.9473C70.707 64.5186 71.1718 64.9833 71.7429 64.9833C72.2176 64.9833 72.6023 65.368 72.6023 65.8427C72.6023 66.3174 72.2176 66.7021 71.7429 66.7021C71.1718 66.7021 70.707 67.1668 70.707 67.738C70.707 68.2127 70.3222 68.5973 69.8477 68.5973Z"
          fill="#6583FE"
        />
        <path
          d="M78.8 61.1636C78.3253 61.1636 77.9407 60.7789 77.9407 60.3042C77.9407 59.7331 77.4759 59.2683 76.9048 59.2683C76.4301 59.2683 76.0454 58.8837 76.0454 58.4089C76.0454 57.9342 76.4301 57.5496 76.9048 57.5496C77.4759 57.5496 77.9407 57.0848 77.9407 56.5137C77.9407 56.039 78.3253 55.6543 78.8 55.6543C79.2748 55.6543 79.6594 56.039 79.6594 56.5137C79.6594 57.0848 80.1242 57.5496 80.6953 57.5496C81.17 57.5496 81.5547 57.9342 81.5547 58.4089C81.5547 58.8837 81.17 59.2683 80.6953 59.2683C80.1242 59.2683 79.6594 59.7331 79.6594 60.3042C79.6594 60.7789 79.2746 61.1636 78.8 61.1636Z"
          fill="#FF7EB8"
        />
        <path
          d="M9.19623 31.5928C8.97623 31.5928 8.7564 31.509 8.58848 31.3411L6.69682 29.4494C6.36115 29.1139 6.36115 28.5697 6.69682 28.2342L8.58848 26.3426C8.92415 26.0069 9.46813 26.0069 9.80381 26.3426L11.6955 28.2342C12.0311 28.5697 12.0311 29.1139 11.6955 29.4494L9.80381 31.3411C9.63606 31.509 9.41623 31.5928 9.19623 31.5928ZM8.5199 28.842L9.19623 29.5183L9.87256 28.842L9.19623 28.1657L8.5199 28.842Z"
          fill="#FF7EB8"
        />
        <path
          d="M12.4147 69.7636C12.1947 69.7636 11.9748 69.6797 11.8069 69.5118L9.91508 67.6203C9.57941 67.2848 9.57941 66.7406 9.91508 66.4051L11.8067 64.5135C12.1424 64.1778 12.6864 64.1778 13.0221 64.5135L14.9137 66.4051C15.2494 66.7406 15.2494 67.2848 14.9137 67.6203L13.0221 69.5119C12.8545 69.6797 12.6347 69.7636 12.4147 69.7636ZM11.7383 67.0127L12.4147 67.689L13.091 67.0127L12.4147 66.3364L11.7383 67.0127Z"
          fill="#97FFD2"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2042_6610"
          x1="2.79493"
          y1="2.39556"
          x2="74.385"
          y2="83.344"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDBED" />
          <stop offset="1" stopColor="#DCFDEE" />
        </linearGradient>
        <clipPath id="clip0_2042_6610">
          <rect width="88" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationServer;
